import type { ReactNode } from "react";

/** A titled block of the admin console: a headline above a Table or Card. */
export function Group({
  title,
  children,
}: {
  title: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-3">
      <h3 className="px-1 text-headline text-fg">{title}</h3>
      {children}
    </div>
  );
}
